const metricsEntityTypes = [
    {value: 0, text: 'Order'},
    {value: 1, text: 'Shipment'},
    {value: 2, text: 'TriggerExecution'},
    {value: 3, text: 'FileExport'},
]

export { metricsEntityTypes as default }